let pendingUser = null;
let pendingGateContext = null;

export function setMfaPending(user, gateContext) {
	pendingUser = user;
	pendingGateContext = gateContext;
}

export function getMfaPending() {
	return { user: pendingUser, gate: pendingGateContext };
}

export function clearMfaPending() {
	pendingUser = null;
	pendingGateContext = null;
}
